module.exports = __webpack_public_path__ + "img/gem-dark-inactive.c0325f35.png";